import _inject from "@stylexjs/stylex/lib/stylex-inject";
import React, { useContext } from 'react';
import * as stylex from '@stylexjs/stylex';
import { AuthContext } from "src/session/AuthProvider";
export default function MainContent(props) {
  var _useContext;
  var user = (_useContext = useContext(AuthContext)) === null || _useContext === void 0 ? void 0 : _useContext.user;
  return /*#__PURE__*/React.createElement("div", stylex.props(ui.base, user !== void 0 && user !== null && ui.hasUser), props.children);
}

// @ts-ignore
_inject(".ev11ycvst{background-color:var(--shade)}", 3000);
_inject(".evixxii4{position:fixed}", 3000);
_inject(".ev13vifvy{top:0}", 4000);
_inject(".ev3m8u43{right:0}", 4000);
_inject(".ev1odjw0f{overflow-y:auto}", 4000);
_inject(".evu96u03{left:0}", 4000);
_inject("@media(max-width:500px){.ev103ggzd.ev103ggzd{left:0}}", 4200);
_inject("@media(max-width:500px){.ev1alxcxo.ev1alxcxo{bottom:0}}", 4200);
_inject("@media(min-width:501px){.evmlui4w.evmlui4w{bottom:0}}", 4200);
_inject(".evpysfdw{left:70px}", 4000);
_inject("@media(max-width:500px){.ev1tkx9bd.ev1tkx9bd{bottom:65px}}", 4200);
var ui = {
  base: {
    "MainContent__ui.base": "MainContent__ui.base",
    backgroundColor: "ev11ycvst",
    position: "evixxii4",
    top: "ev13vifvy",
    right: "ev3m8u43",
    insetInlineStart: null,
    insetInlineEnd: null,
    overflowY: "ev1odjw0f",
    left: "evu96u03",
    "@media(max-width:500px)_left": "ev103ggzd",
    "@media(max-width:500px)_insetInlineStart": null,
    "@media(max-width:500px)_insetInlineEnd": null,
    "@media(max-width:500px)_bottom": "ev1alxcxo",
    "@media(min-width:501px)_bottom": "evmlui4w",
    $$css: true
  },
  hasUser: {
    "MainContent__ui.hasUser": "MainContent__ui.hasUser",
    left: "evpysfdw",
    insetInlineStart: null,
    insetInlineEnd: null,
    "@media(max-width:500px)_bottom": "ev1tkx9bd",
    $$css: true
  }
};